<mat-card>
  <form name="videoForm" [formGroup]="form">
    <h3>YouTube video</h3>
    <p>Your listing may feature a YouTube video, simply enter in the link to your video below.</p>

    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <input matInput placeholder="Video Url"  formControlName="videoUrl" name="video_url" aria-label="Video Url" type="url" (focusout)="trimValue($event,'videoUrl')" (change)="videoUrlChanged($event.target)">
          <mat-label>YouTube link</mat-label>
          <mat-hint>Simply enter in the link to your video.</mat-hint>
          <mat-error *ngIf="form.get('videoUrl').invalid">{{getErrorMessage('videoUrl')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="video-thumbnail-select">
          <div class="loader" *ngIf="thumbnailLoading">
              <mat-spinner matSuffix [diameter]="60" style="color:#97116D"></mat-spinner>
          </div>
          <div *ngIf="!thumbnailLoading">
              <div class="thumb" *ngFor="let thumb of vm.thumbnails">
                  <img src="{{thumb}}" />
                </div>
                <div class="help" *ngIf="vm.thumbnails?.length > 0">
                  <p>The thumbnail above will be displayed on your listing.</p>
                </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline">
          <input matInput formControlName="videoCaption" name="video_caption" aria-label="Video Caption" type="text" (focusout)="trimValue($event,'videoCaption')">
          <mat-label>Video Caption</mat-label>
          <mat-hint>Please provide a description of the video.</mat-hint>
          <mat-error *ngIf="form.get('videoCaption').invalid">{{getErrorMessage('videoCaption')}}</mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-card>